import React from 'react';
import { Alert, Button, Grid, Stack, TextField } from '@mui/material';
import GroupsIcon from '@mui/icons-material/Groups';
import { FWorkbenchShell } from '../workbench';
import { FGrid } from '../grid';
import { GridColDef } from '@mui/x-data-grid';
import {
  createExecutiveReview,
  findExecutiveReviews,
  recommendScenario,
  returnReview,
} from './executiveReview.apis';

type State = {
  rows:any[]; loading:boolean; error:string; success:string;
  planningcycleid:string; reviewid:string; scenariocode:string;
  forecastbatchid:string; name:string; meetingdate:string; comment:string;
};

class ExecutiveReviewWorkbench extends React.Component<any,State> {
  state:State = {
    rows:[],loading:false,error:'',success:'',
    planningcycleid:'',reviewid:'',scenariocode:'',
    forecastbatchid:'',name:'Executive Review',meetingdate:'',comment:'',
  };

  columns:GridColDef[] = [
    {field:'code',headerName:'Review',width:180},
    {field:'planningcyclecode',headerName:'Planning Cycle',width:180},
    {field:'scenariocode',headerName:'Recommended Scenario',width:180},
    {field:'forecastbatchcode',headerName:'Forecast Batch',width:170},
    {field:'readinessscore',headerName:'Readiness %',width:130,type:'number'},
    {field:'statecode',headerName:'State',width:150},
    {field:'executivecomment',headerName:'Executive Comment',flex:1,minWidth:240},
  ];

  componentDidMount(){ this.load(); }

  load = async () => {
    this.setState({loading:true,error:''});
    try {
      const rows = await findExecutiveReviews({
        planningcycleid:this.state.planningcycleid ? Number(this.state.planningcycleid) : null,
        pagesize:50,
      });
      this.setState({rows});
    } catch(err:any) {
      this.setState({error:err.message || String(err)});
    } finally {
      this.setState({loading:false});
    }
  };

  create = async () => {
    const r = await createExecutiveReview({
      planningcycleid:Number(this.state.planningcycleid),
      name:this.state.name,
      meetingdate:this.state.meetingdate || null,
    });
    this.setState({reviewid:String(r.rid),success:'Executive Review created.'});
    await this.load();
  };

  recommend = async () => {
    await recommendScenario({
      reviewid:Number(this.state.reviewid),
      scenariocode:this.state.scenariocode,
      forecastbatchid:this.state.forecastbatchid ? Number(this.state.forecastbatchid) : null,
      comment:this.state.comment,
    });
    this.setState({success:'Scenario recommended.'});
    await this.load();
  };

  sendBack = async () => {
    await returnReview(Number(this.state.reviewid),this.state.comment);
    this.setState({success:'Executive Review returned.'});
    await this.load();
  };

  render() {
    return (
      <FWorkbenchShell
        title="BIE Executive Review"
        subtitle="Recommend one simulation scenario as the planning basis."
        icon={<GroupsIcon/>}
        loading={this.state.loading}
        error={this.state.error}
        success={this.state.success}
        onRefresh={this.load}
      >
        <Stack spacing={2}>
          <Alert severity="info">
            Executive Review ends with recommendation. Determinant Budget consumes the recommendation.
          </Alert>

          <Grid container spacing={2}>
            <Grid size={{xs:12,md:2}}>
              <TextField size="small" label="Planning Cycle ID"
                value={this.state.planningcycleid}
                onChange={(e)=>this.setState({planningcycleid:e.target.value})}
                fullWidth/>
            </Grid>
            <Grid size={{xs:12,md:2}}>
              <TextField size="small" label="Review ID"
                value={this.state.reviewid}
                onChange={(e)=>this.setState({reviewid:e.target.value})}
                fullWidth/>
            </Grid>
            <Grid size={{xs:12,md:2}}>
              <TextField size="small" label="Scenario Code"
                value={this.state.scenariocode}
                onChange={(e)=>this.setState({scenariocode:e.target.value.toUpperCase()})}
                fullWidth/>
            </Grid>
            <Grid size={{xs:12,md:2}}>
              <TextField size="small" label="Forecast Batch ID"
                value={this.state.forecastbatchid}
                onChange={(e)=>this.setState({forecastbatchid:e.target.value})}
                fullWidth/>
            </Grid>
            <Grid size={{xs:12,md:2}}>
              <Button variant="outlined" onClick={this.create} fullWidth>Create Review</Button>
            </Grid>
            <Grid size={{xs:12,md:2}}>
              <Button variant="contained" onClick={this.recommend} fullWidth>Recommend</Button>
            </Grid>
          </Grid>

          <TextField label="Executive Comment / Return Reason"
            value={this.state.comment}
            onChange={(e)=>this.setState({comment:e.target.value})}
            multiline minRows={3} fullWidth/>

          <Button color="warning" variant="outlined" onClick={this.sendBack}>
            Return for Revision
          </Button>

          <FGrid
            title="Executive Reviews"
            subtitle="Recommended scenarios and executive decisions."
            rows={this.state.rows}
            columns={this.columns}
            loading={this.state.loading}
            height={460}
            showQuickFilter
            getRowId={(r:any)=>r.rid}
            onRowClick={(p:any)=>this.setState({
              reviewid:String(p.row.rid),
              scenariocode:p.row.scenariocode || '',
              forecastbatchid:String(p.row.forecastbatchid || ''),
              comment:p.row.executivecomment || '',
            })}
            pageSizeOptions={[10,25,50]}
          />
        </Stack>
      </FWorkbenchShell>
    );
  }
}

export default ExecutiveReviewWorkbench;
